import { mapPoStatus } from "../../../purchase-orders/utils/po-status";

export function statValue(loading: boolean, n: number | null | undefined): string | number {
  if (loading) return "—";
  return n ?? 0;
}

export function toTimestamp(value?: string | null) {
  if (!value) return 0;
  const normalized = value.replace(" ", "T");
  const timestamp = Date.parse(normalized);
  return Number.isNaN(timestamp) ? 0 : timestamp;
}

export function formatStatusLabel(status: ReturnType<typeof mapPoStatus>): string {
  if (status === "inTransit") return "In Transit";
  if (status === "delivered") return "Delivered";
  if (status === "validated") return "Validated";
  if (status === "cancelled") return "Cancelled";
  return "Processing";
}

export function formatRelativeTime(dateStr: string): string {
  const diff = Date.now() - new Date(dateStr).getTime();
  const mins = Math.floor(diff / 60_000);
  if (mins < 1) return "just now";
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  const days = Math.floor(hrs / 24);
  return days === 1 ? "yesterday" : `${days}d ago`;
}
